/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PutResponse } from '../../models/put-response';
import { StoreUpdate } from '../../models/store-update';

export interface StoresStoreIdPut$Params {
  'Active-Tenant-Identifier': string;
  storeId: string;
      body?: StoreUpdate
}

export function storesStoreIdPut(http: HttpClient, rootUrl: string, params: StoresStoreIdPut$Params, context?: HttpContext): Observable<StrictHttpResponse<PutResponse>> {
  const rb = new RequestBuilder(rootUrl, storesStoreIdPut.PATH, 'put');
  if (params) {
    rb.header('Active-Tenant-Identifier', params['Active-Tenant-Identifier'], {});
    rb.path('storeId', params.storeId, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/hal+json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<PutResponse>;
    })
  );
}

storesStoreIdPut.PATH = '/stores/{storeId}';
